import SuperTokens from 'supertokens-web-js'
import Session from 'supertokens-web-js/recipe/session'
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'
import { appInfo } from './appinfo'

export function initSuperTokens() {
  SuperTokens.init({
    appInfo: {
      appName: appInfo.appName,
      apiDomain: appInfo.apiDomain,
      apiBasePath: appInfo.apiBasePath
    },
    recipeList: [
      Session.init({
        sessionTokenFrontendDomain: appInfo.sessionScope
      }),
      EmailPassword.init()
    ]
  })
}
